import { render, staticRenderFns } from "./EmployeeVerificationAfterLoginForm.vue?vue&type=template&id=2bc4421c&scoped=true&"
import script from "./EmployeeVerificationAfterLoginForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeVerificationAfterLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4421c",
  null
  
)

export default component.exports